import { createQueryKeys } from '@lukemorales/query-key-factory';

export const coBrokePayouts = createQueryKeys('coBrokePayouts', {
  agencyDeals: null,
  confirmation: (dealId: string) => [dealId],
  adminOverview: (agencyId: string) => [agencyId],
  adminInvoices: (status: string) => [status],
});
